import React from 'react';
import Icon from '../../../components/AppIcon';

const CoverageOverview = () => {
  const departmentCoverage = [
    {
      id: 1,
      department: "Customer Service",
      currentStaff: 12,
      requiredStaff: 15,
      coverage: 80,
      status: "warning",
      shifts: [
        { time: "06:00-14:00", staff: 4, required: 5 },
        { time: "14:00-22:00", staff: 5, required: 6 },
        { time: "22:00-06:00", staff: 3, required: 4 }
      ]
    },
    {
      id: 2,
      department: "Operations",
      currentStaff: 18,
      requiredStaff: 18,
      coverage: 100,
      status: "success",
      shifts: [
        { time: "06:00-14:00", staff: 6, required: 6 },
        { time: "14:00-22:00", staff: 6, required: 6 },
        { time: "22:00-06:00", staff: 6, required: 6 }
      ]
    },
    {
      id: 3,
      department: "Manufacturing",
      currentStaff: 8,
      requiredStaff: 12,
      coverage: 67,
      status: "error",
      shifts: [
        { time: "06:00-14:00", staff: 3, required: 4 },
        { time: "14:00-22:00", staff: 3, required: 4 },
        { time: "22:00-06:00", staff: 2, required: 4 }
      ]
    },
    {
      id: 4,
      department: "Administration",
      currentStaff: 6,
      requiredStaff: 6,
      coverage: 100,
      status: "success",
      shifts: [
        { time: "08:00-16:00", staff: 6, required: 6 }
      ]
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'success':
        return 'text-success bg-success/10 border-success/20';
      case 'warning':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'error':
        return 'text-error bg-error/10 border-error/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'success':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'error':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Users" size={18} className="text-primary" />
          </div>
          <h3 className="text-lg font-semibold text-foreground">Abdeckungsübersicht</h3>
        </div>
        <div className="flex items-center space-x-2">
          <span className="text-sm text-muted-foreground">Aktualisiert: 16:45</span>
          <Icon name="RefreshCw" size={16} className="text-muted-foreground" />
        </div>
      </div>
      <div className="space-y-4">
        {departmentCoverage?.map((dept) => (
          <div key={dept?.id} className="border border-border rounded-lg p-4 hover:shadow-card transition-shadow">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center space-x-3">
                <div className={`w-3 h-3 rounded-full ${
                  dept?.status === 'success' ? 'bg-success' :
                  dept?.status === 'warning' ? 'bg-warning' : 'bg-error'
                }`} />
                <h4 className="font-medium text-foreground">{dept?.department}</h4>
              </div>
              <div className={`px-2 py-1 rounded-md border text-xs font-medium flex items-center space-x-1 ${getStatusColor(dept?.status)}`}>
                <Icon name={getStatusIcon(dept?.status)} size={12} />
                <span>{dept?.coverage}%</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-3">
              <div className="text-sm">
                <span className="text-muted-foreground">Aktuell: </span>
                <span className="font-medium text-foreground">{dept?.currentStaff}</span>
              </div>
              <div className="text-sm">
                <span className="text-muted-foreground">Benötigt: </span>
                <span className="font-medium text-foreground">{dept?.requiredStaff}</span>
              </div>
            </div>

            <div className="w-full bg-muted rounded-full h-2 mb-3">
              <div 
                className={`h-2 rounded-full transition-all duration-300 ${
                  dept?.status === 'success' ? 'bg-success' :
                  dept?.status === 'warning' ? 'bg-warning' : 'bg-error'
                }`}
                style={{ width: `${dept?.coverage}%` }}
              />
            </div>

            <div className="space-y-2">
              <h5 className="text-xs font-medium text-muted-foreground uppercase tracking-wide">Schichtdetails</h5>
              {dept?.shifts?.map((shift, index) => (
                <div key={index} className="flex items-center justify-between text-xs">
                  <span className="text-muted-foreground">{shift?.time}</span>
                  <span className={`font-medium ${
                    shift?.staff >= shift?.required ? 'text-success' : 'text-error'
                  }`}>
                    {shift?.staff}/{shift?.required}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-3 gap-4 text-center">
          <div>
            <div className="text-lg font-semibold text-success">44</div>
            <div className="text-xs text-muted-foreground">Vollständig besetzt</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-warning">12</div>
            <div className="text-xs text-muted-foreground">Unterbesetzt</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-error">4</div>
            <div className="text-xs text-muted-foreground">Kritisch</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageOverview;